import { Controller } from "stimulus";

const CLASS_WORKING = "is-working";

export default class extends Controller {
    static targets = ["submitButton", "resultMessage", "field", "formRow"];

    async submit(event) {
        event.preventDefault();

        if (!this.validate()) {
            return;
        }

        // Collect the form data *before* disabling the inputs in startWorking()
        const form = new FormData(this.element);

        this.startWorking();

        // Fire Tag directly to GA server once form send has been validated
        this.sendEvent();

        const response = await fetch(this.element.action, {
            method: "post",
            body: form
        });

        const data = await response.json();
        this.resultMessageTarget.innerHTML = data.message;

        if (response.status >= 200 && response.status < 300) {
            this.element.reset();
        }

        this.finishWorking();
    }

    validate() {
        let isValid = true;

        for (let row of this.formRowTargets) {
            row.classList.remove("show");
        }

        for (let i = 0; i < this.fieldTargets.length; i++) {
            const field = this.fieldTargets[i];

            if (!field.validity.valid) {
                const row = this.formRowTargets[i];
                row.classList.add("show");

                isValid = false;
            }
        }

        return isValid;
    }

    startWorking() {
        // Clear the message
        this.resultMessageTarget.innerHTML = "";

        this.submitButtonTarget.disabled = true;
        this.submitButtonTarget.classList.add(CLASS_WORKING);

        for (let i = 0; i < this.fieldTargets.length; i++) {
            this.fieldTargets[i].disabled = true;
        }
    }

    finishWorking() {
        this.submitButtonTarget.disabled = false;
        this.submitButtonTarget.classList.remove(CLASS_WORKING);

        for (let i = 0; i < this.fieldTargets.length; i++) {
            this.fieldTargets[i].disabled = false;
        }
    }

    sendEvent() {
        const { ga } = window;

        if (!ga) {
            console.warn(
                "Google Analytics is not loaded - Can't send form submission event"
            );
            return;
        }

        ga("send", {
            hitType: "event",
            eventCategory: "Form Interactions",
            eventAction: "Form Send",
            eventLabel: "Email Subscription"
        });
    }
}



// WEBPACK FOOTER //
// ./public/assets/scripts/controllers/newsletter-form_controller.js